import { Injectable } from '@angular/core';
import { NotificationsStore } from './notifications.store';
import { ConstantsStore } from '../constants.store';
import { ApiService } from '../api-service';
import { Observable, observable } from 'rxjs';
import { NotificationModel } from 'src/app/models/notificationModel';
import { ObserversModule } from '@angular/cdk/observers';
import { NotificationsData } from 'src/app/models/notificationsData';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    constructor(
        private store: NotificationsStore,
        private constants: ConstantsStore,
        private api: ApiService
    ) { }

    getNotifications(pageNumber: number, pageSize: number, hasBeenSeenFilter: boolean) {
        const hasBeenSeenUri = hasBeenSeenFilter ? `/${true}` : (hasBeenSeenFilter === false) ? `/${false}` : '';
        return this.api.getTableRecordsNoCacheBasic<NotificationsData>(this.constants.notificationsUrl + '/' + pageNumber + '/' + pageSize + hasBeenSeenUri);
    }

    deleteNotifications(id: number) {
        return this.api.delete(this.constants.notificationsUrl, id);
    }

    patchNotifications(notification: NotificationModel) {
        return this.api.patch(this.constants.notificationsUrl, notification);
    }

    getDropdownNotifications() {
        return new Observable(observer => {
            this.getNotifications(1, 5, false)
            .subscribe(
                results => {
                    this.store.loadDropdownRecords(results.records);
                    this.store.totalRecords = results.totalRecords;
                    this.store.totalUnreadNotifications = results.totalUnreadNotifications;
                    observer.next(true);
                },
                err => observer.error(false)
            );
            });
    }

    get(pageNumber: number = 1, pageSize = 20, hasBeenSeenFilter: boolean = null): Observable<any> {
        return new Observable(observer => {
            this.getNotifications(pageNumber, pageSize, hasBeenSeenFilter)
            .subscribe(
                results => {
                    this.store.loadRecords(results.records);
                    this.store.totalRecords = results.totalRecords;
                    this.store.totalUnreadNotifications = results.totalUnreadNotifications;
                    observer.next(true);
                },
                err => observer.error(false)
            );
            });
    }

    getToPromise(pageNumber: number = 1, pageSize = 20, hasBeenSeenFilter: boolean = null): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getNotifications(pageNumber, pageSize, hasBeenSeenFilter).toPromise()
            .then(
                results => {

                    this.store.loadRecords(results.records);
                    this.store.totalRecords = results.totalRecords;
                    this.store.totalUnreadNotifications = results.totalUnreadNotifications;
                    resolve(results);
                })
            .catch(
                err => reject(err)
            );
            // .subscribe(
            //     results => {
            //         this.store.loadRecords(results.records);
            //         this.store.totalRecords = results.totalRecords;
            //         this.store.totalUnreadNotifications = results.totalUnreadNotifications;
            //         observer.next(true);
            //     },
            //     err => observer.error(false)
            // );
            });
    }

    delete(id: number, pageNumber: number, pageSize: number, hasBeenSeenFilter: boolean = null): Observable<any> {
        return new Observable<any>(oberver => {
            this.deleteNotifications(id)
            .subscribe(
                () => {
                    const toRemove = this.store.notifications.filter(record => record.id === id)[0];
                    if (!toRemove.hasBeenSeen) {
                        this.store.totalUnreadNotifications--;
                    }
                    this.store.notifications.splice(this.store.notifications.indexOf(toRemove), 1);
                    this.store.totalRecords--;

                    this.getDropdownNotifications()
                    .subscribe(
                        () => {},
                        err => console.error(err)
                    );
                    oberver.next(true);
                },
                err => oberver.next(err)
            );
        });
    }

    deleteAll(): Observable<any> {
        return new Observable<any>(oberver => {
            this.api.deleteNoParameters(this.constants.notificationsUrl)
            .subscribe(
                () => {
                   this.store.notifications = [];
                   this.store.dropdownNotifications = [];
                   this.store.totalRecords = 0;
                   this.store.totalUnreadNotifications = 0;
                   oberver.next(true);
                },
                err => oberver.next(err)
            );
        });
    }

    patch(notification: NotificationModel, pageNumber: number, pageSize: number, hasBeenSeenFilter: boolean = null): Observable<any> {
        return new Observable<any>(oberver => {
            this.patchNotifications(notification)
            .subscribe(
                () => {
                    if (this.store.notifications) {
                        if (this.store.notifications.filter(notif => notification.id === notif.id).length) {
                            this.store.notifications.filter(notif => notification.id === notif.id)[0].hasBeenSeen = true;
                            this.store.totalUnreadNotifications--;
                        }
                    }

                    this.getDropdownNotifications()
                    .subscribe(
                        () => {},
                        err => console.error(err)
                    );
                    oberver.next(true);
                },
                err => oberver.next(err)
            );
        });
    }
}
